import { ExternalProofSalesRoomPanel } from "../../../ExternalProofSalesRoomPanel.js";
import { V10EvidenceLegacyScope } from "../components/V10EvidenceLegacyScope.js";
import { V10LaunchProofSection } from "../components/V10LaunchProofSection.js";
import type { V10ClientLinkViewProps } from "../types.js";

export function V10ProofTab({
  active,
  api,
  linkId,
  token,
  externalProofView,
  afterFixProofSummary,
  isExternalProof,
  onGoToSummary,
}: Pick<V10ClientLinkViewProps, "api" | "externalProofView" | "afterFixProofSummary" | "isExternalProof"> & {
  readonly active: boolean;
  readonly linkId: string;
  readonly token: string;
  readonly onGoToSummary?: () => void;
}) {
  return (
    <section
      className={`v10-cl-tab-panel${active ? " active" : ""}`}
      role="tabpanel"
      id="v10-tab-proof"
      aria-labelledby="v10-tab-btn-proof"
      hidden={!active}
    >
      {isExternalProof && externalProofView ? (
        <>
          {externalProofView.approvalState !== "approved" && onGoToSummary ? (
            <div className="v10-cl-actions v10-cl-proof-cta">
              <p className="v10-cl-muted">Review the proof details below, then approve on the Summary tab.</p>
              <button type="button" className="v10-cl-btn v10-cl-btn--gold" onClick={onGoToSummary}>
                Go to Summary to approve
              </button>
            </div>
          ) : null}
          <ExternalProofSalesRoomPanel
            view={externalProofView}
            canAct={false}
            changeMessage=""
            setChangeMessage={() => {}}
            onApprove={() => {}}
            onRequestChange={() => {}}
            actionStatus={null}
          />
        </>
      ) : (
        <V10EvidenceLegacyScope>
          <V10LaunchProofSection api={api} linkId={linkId} token={token} enabled={active} />
        </V10EvidenceLegacyScope>
      )}
      {!isExternalProof && afterFixProofSummary ? (
        <p className="v10-cl-muted v10-cl-proof-footnote">{afterFixProofSummary.headline}</p>
      ) : null}
    </section>
  );
}
